var _defs, _polygon, _polygon2, _circle, _circle2, _g, _path, _rect, _rect2, _rect3, _rect4, _g2, _path2, _line, _rect5, _rect6, _line2, _rect7, _line3, _rect8, _path3, _polygon3, _circle3, _rect9, _rect10, _polygon4, _polygon5, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _path5, _path6, _path7, _circle4, _circle5, _rect17, _rect18, _g3, _path8, _rect19, _rect20, _rect21, _rect22, _g4, _path9, _line4, _rect23, _rect24, _line5, _rect25, _line6, _rect26, _polyline, _rect27, _rect28, _rect29, _rect30, _circle6, _circle7, _circle8, _circle9, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _g5, _path10, _rect37, _rect38, _rect39, _rect40, _g6, _path11, _line7, _rect41, _rect42, _line8, _rect43, _line9, _rect44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba7a25ce-c07b-4ac4-a0ea-a259ac25350d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 886,
    height: 757.3,
    viewBox: "0 0 886 757.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed8d860b-00cf-433a-95e5-cbf5c617e18b",
    x1: 709,
    y1: 237.54,
    x2: 768,
    y2: 237.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6339929e-befe-4c3c-83b4-b4b07511d1c6",
    x1: 816,
    y1: 110,
    x2: 816,
    y2: 0,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c68f5f28-28ea-478e-a627-cc48dbc11db2",
    x1: 347.64,
    y1: 559.73,
    x2: 347.64,
    y2: 158.42,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af0c75ea-b6a9-473b-a441-46b6eb7aabaa",
    x1: 205.4,
    y1: 660.58,
    x2: 205.4,
    y2: 215.07,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "07c293ef-2e04-47b9-9dab-05744944918b",
    x1: 527.17,
    y1: 577.53,
    x2: 527.17,
    y2: 241.78,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "99ecabf1-6663-4199-9e30-2b1879a6e68f",
    x1: 356.61,
    y1: 658.33,
    x2: 356.61,
    y2: 284.4,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5323f77-a164-4403-a4a3-e3bb80b3dd3a",
    x1: 719.08,
    y1: 790.22,
    x2: 719.08,
    y2: 410,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2adf7edc-03a9-497d-bc9b-be51c3b9abee",
    x1: 561.04,
    y1: 372.91,
    x2: 561.04,
    y2: 256.23,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc6d08f3-e0d9-4b30-9f4b-e3e40f68421d",
    x1: 400.09,
    y1: 530.21,
    x2: 400.09,
    y2: 427.08,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b061de97-efb2-47d4-a738-e03d872c7bb2",
    x1: 719.9,
    y1: 530.21,
    x2: 719.9,
    y2: 427.08,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "629934b4-7f6d-4a9f-b25a-bd23c5ea943e",
    x1: 560.01,
    y1: 430.7,
    x2: 560.01,
    y2: 100.75,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff5f70b0-5412-4b05-8af3-9cc71edd9fb3",
    x1: 560.52,
    y1: 716.16,
    x2: 560.52,
    y2: 543.75,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "55ccc14f-2d64-46f4-b390-94f238de28f8",
    x1: 592.29,
    y1: 643.76,
    x2: 592.29,
    y2: 618.76,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc666d0b-2aa0-4660-9d56-037189502a05",
    x1: 558.44,
    y1: 741.68,
    x2: 558.44,
    y2: 691.68,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa11ad7e-aa97-42a8-8299-cf9535b348d8",
    x1: 424.15,
    y1: 725.92,
    x2: 424.15,
    y2: 540.93,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "54170ddb-90d4-4c6b-9aec-414726b57e5b",
    x1: 273.95,
    y1: 740.07,
    x2: 273.95,
    y2: 534.71,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "35371f95-6706-4e56-a6fb-3c3dca9d719e",
    x1: 506.91,
    y1: 734.12,
    x2: 506.91,
    y2: 579.36,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "71e42c26-8972-4331-ac1b-fe8028f46264",
    x1: 343.65,
    y1: 739.03,
    x2: 343.65,
    y2: 566.66,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b530f945-63fc-46f4-8c64-420d03be0b8a",
    x1: 45.22,
    y1: 748.2,
    x2: 45.22,
    y2: 468.2,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6434ea8d-22a5-4ded-b4fb-b816fb6aaf11",
    x1: 147,
    y1: 528.64,
    x2: 147,
    y2: 479.76,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce587cc2-5f44-4d09-a37f-cbd1d4582cbf",
    x1: 45.67,
    y1: 511.76,
    x2: 45.67,
    y2: 495.76,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "44f2908b-b842-425b-90b7-6a504dcafb19",
    x1: 259.89,
    y1: 511.76,
    x2: 259.89,
    y2: 495.76,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "18c6eef5-8ad4-4423-849c-53e6d88fcc26",
    x1: 75.89,
    y1: 627.76,
    x2: 247.44,
    y2: 627.76,
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6cad729a-3ab6-44c4-8c11-5c0a64ee20ab",
    x1: 500.45,
    y1: 749.89,
    x2: 500.45,
    y2: 581.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 1458.08, 0)",
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6203ec6-a956-4b17-9931-78587025ff07",
    x1: 506.63,
    y1: 817.3,
    x2: 506.63,
    y2: 630.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 1301.08, -60)",
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6cb1d8e-c69c-4d33-a5df-3c3a5a49df8c",
    x1: 575.69,
    y1: 757.35,
    x2: 575.69,
    y2: 616.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 1458.08, 0)",
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7de7dbdc-b07f-446b-8432-6deb6240c5ca",
    x1: 570.01,
    y1: 816.36,
    x2: 570.01,
    y2: 659.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 1301.08, -60)",
    xlinkHref: "#ed8d860b-00cf-433a-95e5-cbf5c617e18b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "for sale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "709 242.4 709 176 768 176 768 299.07 709 242.4",
    fill: "url(#ed8d860b-00cf-433a-95e5-cbf5c617e18b)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "716 247 716 189 760 189 760 299.07 716 247",
    fill: "#e87100"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 55,
    r: 55,
    fill: "url(#6339929e-befe-4c3c-83b4-b4b07511d1c6)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 55,
    r: 44,
    fill: "#ff9800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f741385e-e577-4271-b030-1aa9bd75830a",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.49,365.47A86.18,86.18,0,0,0,484.7,236.57a51,51,0,0,0,8.16-27.75c0-27.84-22.07-50.41-49.29-50.41-22.42,0-41.32,15.33-47.29,36.29-12.87-21.75-36.22-36.29-62.89-36.29-40.57,0-73.45,33.63-73.45,75.12a76.49,76.49,0,0,0,4.5,25.93c-1.49-.12-3-.23-4.5-.23-32.56,0-59,27-59,60.3,0,2.05.1,4.08.3,6.09A74.94,74.94,0,0,0,157,394.41c0,41.35,32.78,74.88,73.21,74.88a72,72,0,0,0,12.67-1.14c-.22,2.49-.35,5-.35,7.57,0,46.4,36.78,84,82.15,84a80.5,80.5,0,0,0,46.78-15,60.29,60.29,0,0,0,39.72,15c33.89,0,61.37-28.1,61.37-62.77,0-1.5-.12-3-.22-4.45h.22c36.3,0,65.72-30.09,65.72-67.21A67.38,67.38,0,0,0,502.49,365.47Z",
    transform: "translate(-157 -60)",
    fill: "url(#c68f5f28-28ea-478e-a627-cc48dbc11db2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "aa86aca2-1def-4b5e-bdbf-3429bf39090e",
    "data-name": "<Path>",
    d: "M493,365.07a80.89,80.89,0,0,0-16.7-121,47.84,47.84,0,0,0,7.66-26c0-26.13-20.71-47.32-46.27-47.32-21,0-38.78,14.39-44.39,34.06a68.61,68.61,0,0,0-59-34.06c-38.08,0-68.95,31.57-68.95,70.51a71.8,71.8,0,0,0,4.22,24.34c-1.4-.11-2.8-.22-4.22-.22C234.75,265.37,210,290.7,210,322c0,1.93.1,3.83.28,5.71a70.34,70.34,0,0,0-41.56,64.57c0,38.82,30.77,70.28,68.72,70.28a67.57,67.57,0,0,0,11.89-1.07c-.2,2.34-.33,4.71-.33,7.1,0,43.55,34.52,78.86,77.11,78.86a75.56,75.56,0,0,0,43.91-14,56.59,56.59,0,0,0,37.28,14c31.81,0,57.61-26.38,57.61-58.92,0-1.41-.11-2.79-.21-4.18h.21c34.07,0,61.69-28.25,61.69-63.09A63.24,63.24,0,0,0,493,365.07Z",
    transform: "translate(-157 -60)",
    fill: "#00897b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 196.44,
    y: 215.07,
    width: 17.91,
    height: 445.51,
    fill: "url(#af0c75ea-b6a9-473b-a441-46b6eb7aabaa)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201.53,
    y: 221.33,
    width: 9.01,
    height: 439.25,
    fill: "#795548"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 343.58,
    y: 369.44,
    width: 108.81,
    height: 9.01,
    transform: "translate(-303.8 351.85) rotate(-47.2)",
    fill: "#795548"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 318.19,
    y: 406.26,
    width: 9.01,
    height: 95.48,
    transform: "translate(-391.19 382.39) rotate(-53.4)",
    fill: "#795548"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b1e29bf6-85c6-472a-ba69-b630e8d8f49d",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390,415a69.52,69.52,0,0,1-18.86-47.52c0-25.44,13.83-47.74,34.61-60.31A41,41,0,0,1,398.57,284c0-23.29,19.54-42.17,43.65-42.17,19.86,0,36.59,12.82,41.88,30.36a65.5,65.5,0,0,1,55.69-30.36c35.93,0,65,28.14,65,62.85a60.83,60.83,0,0,1-4,21.69c1.32-.1,2.64-.19,4-.19,28.84,0,52.21,22.58,52.21,50.44a49.31,49.31,0,0,1-.27,5.09c23.06,9.6,39.21,31.75,39.21,57.55,0,34.6-29,62.64-64.84,62.64a67.38,67.38,0,0,1-11.22-1c.19,2.09.31,4.19.31,6.33,0,38.82-32.57,70.29-72.75,70.29A74.16,74.16,0,0,1,506.07,565a55.23,55.23,0,0,1-35.18,12.52c-30,0-54.35-23.51-54.35-52.51,0-1.26.1-2.49.19-3.73h-.19c-32.14,0-58.2-25.18-58.2-56.23C358.34,443.23,371.23,424.32,390,415Z",
    transform: "translate(-157 -60)",
    fill: "url(#07c293ef-2e04-47b9-9dab-05744944918b)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "da8ae254-7852-462b-b033-1b79dc847a6a",
    "data-name": "<Path>",
    d: "M395.91,414.77a66.54,66.54,0,0,1-18-45.49c0-24.35,13.24-45.69,33.13-57.72a39.2,39.2,0,0,1-6.91-22.22c0-22.29,18.71-40.37,41.78-40.37,19,0,35,12.27,40.09,29.06A62.7,62.7,0,0,1,539.25,249c34.39,0,62.26,26.93,62.26,60.15a58.22,58.22,0,0,1-3.81,20.77c1.26-.09,2.52-.19,3.81-.19,27.6,0,50,21.62,50,48.28a47.2,47.2,0,0,1-.25,4.87c22.07,9.19,37.53,30.39,37.53,55.08,0,33.11-27.78,60-62.06,60A64.49,64.49,0,0,1,616,497c.18,2,.29,4,.29,6.06,0,37.16-31.18,67.28-69.63,67.28a71,71,0,0,1-39.65-12,52.86,52.86,0,0,1-33.67,12c-28.73,0-52-22.5-52-50.26,0-1.2.1-2.38.19-3.57h-.19c-30.77,0-55.71-24.1-55.71-53.82C365.58,441.79,377.91,423.69,395.91,414.77Z",
    transform: "translate(-157 -60)",
    fill: "#009688"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "d827a518-3361-4086-b50f-c6b47e6818cd",
    "data-name": "<Path>",
    x1: 356.95,
    y1: 284.4,
    x2: 356.95,
    y2: 658.33,
    fill: "#795548"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 346.43,
    y: 284.4,
    width: 20.37,
    height: 373.92,
    fill: "url(#99ecabf1-6663-4199-9e30-2b1879a6e68f)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 351.32,
    y: 284.4,
    width: 11.26,
    height: 373.92,
    fill: "#795548"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "4a2b3956-f53f-4918-93e5-f7b78a79ae92",
    "data-name": "<Path>",
    x1: 358.09,
    y1: 396.39,
    x2: 291.32,
    y2: 328.28,
    fill: "#795548"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 476.07,
    y: 374.65,
    width: 11.26,
    height: 95.38,
    transform: "translate(-314.94 397.95) rotate(-44.43)",
    fill: "#795548"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "100a92bc-a3f1-4f9a-a93f-0d91ae55d71b",
    "data-name": "<Path>",
    x1: 358.09,
    y1: 454.93,
    x2: 427.31,
    y2: 406.36,
    fill: "#795548"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 507.42,
    y: 485.01,
    width: 84.56,
    height: 11.26,
    transform: "translate(-339.1 344.78) rotate(-35.06)",
    fill: "#795548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M970.21,410H468c-11.47,0-20.76,5.16-20.76,11.54V790.22H991V421.54C991,415.16,981.68,410,970.21,410Z",
    transform: "translate(-157 -60)",
    fill: "url(#a5323f77-a164-4403-a4a3-e3bb80b3dd3a)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.52 139.04 298.53 333.64 298.53 716.16 824.08 716.16 824.08 347.52 560.52 139.04",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.04,
    cy: 314.57,
    r: 58.34,
    fill: "url(#2adf7edc-03a9-497d-bc9b-be51c3b9abee)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 348.53,
    y: 427.08,
    width: 103.13,
    height: 103.13,
    fill: "url(#fc6d08f3-e0d9-4b30-9f4b-e3e40f68421d)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 668.34,
    y: 427.08,
    width: 103.13,
    height: 103.13,
    fill: "url(#b061de97-efb2-47d4-a738-e03d872c7bb2)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "248 430.7 234.03 352.56 561.67 100.75 886 357.59 877 427.7 561.62 189.72 248 430.7",
    fill: "url(#629934b4-7f6d-4a9f-b25a-bd23c5ea943e)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.64 415.01 239.03 361.02 561.59 109.32 881 361.04 871.33 414.98 561.54 170.84 248.64 415.01",
    fill: "#e87100"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 497.5,
    y: 543.75,
    width: 126.05,
    height: 172.41,
    fill: "url(#ff5f70b0-5412-4b05-8af3-9cc71edd9fb3)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 501.14,
    y: 547.4,
    width: 118.76,
    height: 168.76,
    fill: "#e87100"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 353.22,
    y: 430.72,
    width: 95.84,
    height: 33.86,
    fill: "#e87100"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 353.22,
    y: 464.58,
    width: 95.84,
    height: 61.98,
    fill: "#e87100",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 671.99,
    y: 430.72,
    width: 95.84,
    height: 33.86,
    fill: "#e87100"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 671.99,
    y: 464.58,
    width: 95.84,
    height: 61.98,
    fill: "#e87100",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M717.52,427.18A53.13,53.13,0,0,0,770.65,374H664.39A53.13,53.13,0,0,0,717.52,427.18Z",
    transform: "translate(-157 -60)",
    fill: "#e87100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M717.52,426.66a53.13,53.13,0,0,0,53.13-53.13H664.39A53.13,53.13,0,0,0,717.52,426.66Z",
    transform: "translate(-157 -60)",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M717.52,320.92A53.13,53.13,0,0,0,664.39,374H770.65A53.13,53.13,0,0,0,717.52,320.92Z",
    transform: "translate(-157 -60)",
    fill: "#e87100",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M717.52,320.92A53.13,53.13,0,0,0,664.39,374H770.65A53.13,53.13,0,0,0,717.52,320.92Z",
    transform: "translate(-157 -60)",
    fill: "#e87100",
    opacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.29,
    cy: 631.26,
    r: 12.5,
    fill: "url(#55ccc14f-2d64-46f4-b390-94f238de28f8)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.29,
    cy: 631.26,
    r: 9.38,
    fill: "#263238"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 481.87,
    y: 691.68,
    width: 153.13,
    height: 50,
    fill: "url(#dc666d0b-2aa0-4660-9d56-037189502a05)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 484.99,
    y: 695.84,
    width: 146.88,
    height: 42.71,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "06ed4a51-c0d7-4f18-ace3-f8895d5abf4f",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.53,636.37a39.73,39.73,0,0,0-8.2-59.41,23.49,23.49,0,0,0,3.76-12.79,22.66,22.66,0,0,0-44.52-6.51,33.69,33.69,0,0,0-29-16.73c-18.7,0-33.86,15.5-33.86,34.63a35.26,35.26,0,0,0,2.07,12c-.69-.05-1.37-.11-2.07-.11-15,0-27.18,12.44-27.18,27.79,0,.95,0,1.88.14,2.81a34.55,34.55,0,0,0-20.41,31.71c0,19.06,15.11,34.51,33.75,34.51a33.18,33.18,0,0,0,5.84-.53c-.1,1.15-.16,2.31-.16,3.49,0,21.39,17,38.73,37.87,38.73a37.11,37.11,0,0,0,21.56-6.9,27.79,27.79,0,0,0,18.31,6.9c15.62,0,28.29-13,28.29-28.93,0-.69-.05-1.37-.1-2.05h.1c16.73,0,30.29-13.87,30.29-31A31.06,31.06,0,0,0,495.53,636.37Z",
    transform: "translate(-157 -60)",
    fill: "url(#fa11ad7e-aa97-42a8-8299-cf9535b348d8)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "78683fa5-7813-42ce-9e3f-16828d09ffb2",
    "data-name": "<Path>",
    d: "M491.15,636.19a37.29,37.29,0,0,0-7.7-55.77,22.05,22.05,0,0,0,3.53-12,21.27,21.27,0,0,0-41.79-6.11A31.63,31.63,0,0,0,418,546.61c-17.55,0-31.78,14.55-31.78,32.5a33.1,33.1,0,0,0,1.95,11.22c-.64,0-1.29-.1-1.95-.1-14.09,0-25.51,11.68-25.51,26.09,0,.89,0,1.77.13,2.63a32.43,32.43,0,0,0-19.16,29.76c0,17.89,14.18,32.4,31.68,32.4a31.15,31.15,0,0,0,5.48-.49c-.09,1.08-.15,2.17-.15,3.27,0,20.08,15.91,36.35,35.54,36.35a34.83,34.83,0,0,0,20.24-6.48,26.09,26.09,0,0,0,17.19,6.48c14.67,0,26.55-12.16,26.55-27.16,0-.65-.05-1.29-.1-1.93h.1c15.7,0,28.44-13,28.44-29.08A29.15,29.15,0,0,0,491.15,636.19Z",
    transform: "translate(-157 -60)",
    fill: "#00897b"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 269.82,
    y: 534.71,
    width: 8.26,
    height: 205.36,
    fill: "url(#54170ddb-90d4-4c6b-9aec-414726b57e5b)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 272.17,
    y: 537.59,
    width: 4.15,
    height: 202.48,
    fill: "#795548"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 422.28,
    y: 638.2,
    width: 50.16,
    height: 4.15,
    transform: "translate(-483.38 473.44) rotate(-47.2)",
    fill: "#795548"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 410.57,
    y: 655.18,
    width: 4.15,
    height: 44.01,
    transform: "translate(-534.04 544.73) rotate(-53.4)",
    fill: "#795548"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "972b0d41-b6e5-4c12-bd64-332f8d6d9bc4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.69,659.21A32,32,0,0,1,435,637.3a32.52,32.52,0,0,1,16-27.8,18.88,18.88,0,0,1-3.33-10.7c0-10.74,9-19.44,20.12-19.44a20,20,0,0,1,19.31,14,30.19,30.19,0,0,1,25.67-14c16.56,0,30,13,30,29a28,28,0,0,1-1.84,10c.61,0,1.22-.09,1.84-.09,13.29,0,24.07,10.41,24.07,23.25a22.73,22.73,0,0,1-.12,2.35,28.88,28.88,0,0,1,18.07,26.53c0,15.95-13.38,28.88-29.89,28.88a31.06,31.06,0,0,1-5.17-.44c.09,1,.14,1.93.14,2.92,0,17.89-15,32.4-33.54,32.4a34.19,34.19,0,0,1-19.1-5.77A25.46,25.46,0,0,1,481,734.12c-13.84,0-25.05-10.84-25.05-24.21,0-.58,0-1.15.09-1.72h-.09c-14.82,0-26.83-11.61-26.83-25.92A25.83,25.83,0,0,1,443.69,659.21Z",
    transform: "translate(-157 -60)",
    fill: "url(#35371f95-6706-4e56-a6fb-3c3dca9d719e)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "b9cc99c1-468f-47c5-9d53-f370b6656f3a",
    "data-name": "<Path>",
    d: "M446.4,659.1a30.67,30.67,0,0,1-8.32-21,31.13,31.13,0,0,1,15.27-26.61,18.07,18.07,0,0,1-3.19-10.24c0-10.28,8.62-18.61,19.26-18.61a19.18,19.18,0,0,1,18.48,13.39,28.9,28.9,0,0,1,24.57-13.39c15.85,0,28.7,12.41,28.7,27.73a26.84,26.84,0,0,1-1.76,9.57c.58,0,1.16-.09,1.76-.09,12.72,0,23,10,23,22.26a21.76,21.76,0,0,1-.12,2.25,27.64,27.64,0,0,1,17.3,25.39c0,15.26-12.81,27.64-28.61,27.64a29.73,29.73,0,0,1-5-.42c.09.92.14,1.85.14,2.79,0,17.13-14.37,31-32.1,31a32.72,32.72,0,0,1-18.28-5.52,24.37,24.37,0,0,1-15.52,5.52c-13.24,0-24-10.37-24-23.17,0-.55,0-1.1.09-1.64h-.09c-14.18,0-25.68-11.11-25.68-24.81A24.72,24.72,0,0,1,446.4,659.1Z",
    transform: "translate(-157 -60)",
    fill: "#009688"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "7a451371-7fbb-4ddd-b5af-3dcf3eef4c8e",
    "data-name": "<Path>",
    x1: 343.81,
    y1: 566.66,
    x2: 343.81,
    y2: 739.03,
    fill: "#795548"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 338.96,
    y: 566.66,
    width: 9.39,
    height: 172.36,
    fill: "url(#71e42c26-8972-4331-ac1b-fe8028f46264)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 341.22,
    y: 566.66,
    width: 5.19,
    height: 172.36,
    fill: "#795548"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "f8907fab-e671-432b-8785-92f5b3540283",
    "data-name": "<Path>",
    x1: 344.34,
    y1: 618.29,
    x2: 313.56,
    y2: 586.89,
    fill: "#795548"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 483.35,
    y: 640.61,
    width: 5.19,
    height: 43.97,
    transform: "translate(-481.91 469.61) rotate(-44.43)",
    fill: "#795548"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "83bfd14d-9fcf-4efd-aa6d-a51063723d88",
    "data-name": "<Path>",
    x1: 344.34,
    y1: 645.27,
    x2: 376.25,
    y2: 622.88,
    fill: "#795548"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 497.8,
    y: 691.48,
    width: 38.98,
    height: 5.19,
    transform: "translate(-461.83 363.07) rotate(-35.06)",
    fill: "#795548"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "89.22 503.76 156.78 573.98 233.22 503.76",
    fill: "none",
    stroke: "#37474f",
    strokeMiterlimit: 10
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 22.56,
    y: 468.2,
    width: 45.33,
    height: 280,
    fill: "url(#b530f945-63fc-46f4-8c64-420d03be0b8a)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 26.11,
    y: 473.53,
    width: 38.22,
    height: 264.89,
    fill: "#f5f5f5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 479.76,
    width: 272,
    height: 48.89,
    fill: "url(#6434ea8d-22a5-4ded-b4fb-b816fb6aaf11)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 284.89,
    y: 431.76,
    width: 38.22,
    height: 264.89,
    transform: "translate(-417.2 808.2) rotate(-90)",
    fill: "#f5f5f5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.67,
    cy: 503.76,
    r: 8,
    fill: "url(#ce587cc2-5f44-4d09-a37f-cbd1d4582cbf)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.89,
    cy: 503.76,
    r: 8,
    fill: "url(#44f2908b-b842-425b-90b7-6a504dcafb19)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.67,
    cy: 503.76,
    r: 6.22,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.89,
    cy: 503.76,
    r: 6.22,
    fill: "#e6e6e6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 75.89,
    y: 569.53,
    width: 171.56,
    height: 116.44,
    fill: "url(#18c6eef5-8ad4-4423-849c-53e6d88fcc26)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 77.22,
    y: 570.87,
    width: 168.89,
    height: 112,
    fill: "#e87100"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 96.78,
    y: 588.64,
    width: 119.11,
    height: 10.67,
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 118.56,
    y: 609.53,
    width: 84.44,
    height: 10.67,
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 107.89,
    y: 630.42,
    width: 102.22,
    height: 10.67,
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 98.11,
    y: 651.31,
    width: 119.11,
    height: 10.67,
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "63650477-b8a1-43d8-a2c1-7cd9fae56092",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M892.74,668.47a36.12,36.12,0,0,1,7.46-54,21.36,21.36,0,0,1-3.42-11.63,20.6,20.6,0,0,1,40.48-5.92,30.63,30.63,0,0,1,26.36-15.21c17,0,30.78,14.1,30.78,31.48a32.06,32.06,0,0,1-1.88,10.87c.62,0,1.25-.1,1.88-.1,13.65,0,24.71,11.31,24.71,25.27,0,.86,0,1.71-.13,2.55a31.41,31.41,0,0,1,18.56,28.83c0,17.33-13.74,31.38-30.68,31.38a30.17,30.17,0,0,1-5.31-.48c.09,1,.15,2.1.15,3.17,0,19.45-15.41,35.21-34.43,35.21a33.74,33.74,0,0,1-19.61-6.27A25.27,25.27,0,0,1,931,749.89c-14.2,0-25.72-11.78-25.72-26.31,0-.63,0-1.25.09-1.87h-.09c-15.21,0-27.54-12.61-27.54-28.17A28.24,28.24,0,0,1,892.74,668.47Z",
    transform: "translate(-157 -60)",
    fill: "url(#6cad729a-3ab6-44c4-8c11-5c0a64ee20ab)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "d9fb3d72-af8e-4f1d-b977-47710d21b422",
    "data-name": "<Path>",
    d: "M896.72,668.31a33.9,33.9,0,0,1,7-50.7,20,20,0,0,1-3.21-10.91,19.34,19.34,0,0,1,38-5.56,28.75,28.75,0,0,1,24.74-14.28c16,0,28.89,13.23,28.89,29.55a30.09,30.09,0,0,1-1.77,10.2c.59,0,1.17-.09,1.77-.09,12.81,0,23.19,10.62,23.19,23.72,0,.81,0,1.61-.12,2.39a29.48,29.48,0,0,1,17.42,27.06c0,16.27-12.89,29.45-28.8,29.45a28.32,28.32,0,0,1-5-.45c.09,1,.14,2,.14,3,0,18.25-14.47,33.05-32.32,33.05a31.67,31.67,0,0,1-18.4-5.89,23.72,23.72,0,0,1-15.62,5.89c-13.33,0-24.14-11.05-24.14-24.69,0-.59,0-1.17.09-1.75h-.09c-14.28,0-25.85-11.84-25.85-26.44A26.51,26.51,0,0,1,896.72,668.31Z",
    transform: "translate(-157 -60)",
    fill: "#00897b"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 790.69,
    y: 570.59,
    width: 7.51,
    height: 186.71,
    fill: "url(#b6203ec6-a956-4b17-9931-78587025ff07)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 792.29,
    y: 573.21,
    width: 3.78,
    height: 184.09,
    fill: "#795548"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 934.64,
    y: 649.22,
    width: 3.78,
    height: 45.6,
    transform: "translate(-364.22 755.33) rotate(-42.8)",
    fill: "#795548"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 948.08,
    y: 703.69,
    width: 40.02,
    height: 3.78,
    transform: "translate(-386.79 656.31) rotate(-36.6)",
    fill: "#795548"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ea5e6e86-8f22-4c0d-a253-147f504d396e",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M939.86,689.23a29.13,29.13,0,0,0,7.9-19.92A29.57,29.57,0,0,0,933.26,644a17.16,17.16,0,0,0,3-9.73c0-9.76-8.19-17.68-18.29-17.68a18.21,18.21,0,0,0-17.55,12.72,27.45,27.45,0,0,0-23.34-12.72c-15.06,0-27.26,11.79-27.26,26.34a25.49,25.49,0,0,0,1.67,9.09c-.55,0-1.11-.08-1.67-.08-12.08,0-21.88,9.46-21.88,21.14a20.67,20.67,0,0,0,.11,2.13,26.25,26.25,0,0,0-16.43,24.12c0,14.5,12.17,26.25,27.17,26.25a28.24,28.24,0,0,0,4.7-.4c-.08.87-.13,1.76-.13,2.65,0,16.27,13.65,29.46,30.49,29.46a31.08,31.08,0,0,0,17.36-5.25A23.15,23.15,0,0,0,906,757.35c12.58,0,22.78-9.85,22.78-22,0-.53,0-1-.08-1.56h.08c13.47,0,24.39-10.55,24.39-23.57A23.48,23.48,0,0,0,939.86,689.23Z",
    transform: "translate(-157 -60)",
    fill: "url(#b6cb1d8e-c69c-4d33-a5df-3c3a5a49df8c)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "79f8c247-f548-4c1c-8f49-a16aaa215201",
    "data-name": "<Path>",
    d: "M937.4,689.14A27.89,27.89,0,0,0,945,670.07a28.3,28.3,0,0,0-13.88-24.19,16.43,16.43,0,0,0,2.9-9.31c0-9.34-7.84-16.92-17.51-16.92a17.43,17.43,0,0,0-16.8,12.18,26.28,26.28,0,0,0-22.34-12.18c-14.41,0-26.09,11.29-26.09,25.21a24.4,24.4,0,0,0,1.6,8.7c-.53,0-1.06-.08-1.6-.08-11.57,0-20.94,9.06-20.94,20.23a19.78,19.78,0,0,0,.11,2,25.13,25.13,0,0,0-15.73,23.08c0,13.88,11.64,25.13,26,25.13a27,27,0,0,0,4.5-.38c-.08.84-.12,1.68-.12,2.54,0,15.57,13.07,28.2,29.18,28.2a29.75,29.75,0,0,0,16.62-5,22.15,22.15,0,0,0,14.11,5c12,0,21.8-9.43,21.8-21.06,0-.5,0-1-.08-1.49h.08c12.89,0,23.35-10.1,23.35-22.56A22.48,22.48,0,0,0,937.4,689.14Z",
    transform: "translate(-157 -60)",
    fill: "#009688"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "86901f0c-b7b5-4ba8-942f-e54f281a8bcd",
    "data-name": "<Path>",
    x1: 730.93,
    y1: 599.65,
    x2: 730.93,
    y2: 756.36,
    fill: "#795548"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 726.81,
    y: 599.65,
    width: 8.54,
    height: 156.71,
    fill: "url(#7de7dbdc-b07f-446b-8432-6deb6240c5ca)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 728.57,
    y: 599.65,
    width: 4.72,
    height: 156.71,
    fill: "#795548"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "63650f42-d3c3-489e-a647-f3904e46b7bd",
    "data-name": "<Path>",
    x1: 730.46,
    y1: 646.58,
    x2: 758.44,
    y2: 618.04,
    fill: "#795548"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 881.46,
    y: 689.95,
    width: 39.97,
    height: 4.72,
    transform: "translate(-380.98 791.4) rotate(-45.57)",
    fill: "#795548"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "25077b7e-584e-4c29-8c8c-a60ca5d6c1ae",
    "data-name": "<Path>",
    x1: 730.46,
    y1: 671.11,
    x2: 701.44,
    y2: 650.76,
    fill: "#795548"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 870.59,
    y: 703.21,
    width: 4.72,
    height: 35.44,
    transform: "translate(-375.62 961.38) rotate(-54.94)",
    fill: "#795548"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.2371b3b1.svg";
export { ForwardRef as ReactComponent };